import React, { useCallback, useState } from "react";
import { Platform } from "react-native";

export default function useCopyText() {
  const [copied, setCopied] = useState(false);
  const copyText = useCallback(async (text: string) => {
    if (Platform.OS !== "web" || !navigator.clipboard) return;
    await navigator.clipboard.writeText(text);
    setCopied(true);
  }, []);

  return { copyText, copied };
}
